import React, { Component, Fragment } from 'react';
import { StyleServices,UtilityService } from '../../services';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import AlertContainer from 'react-alert';

class Smv_Ov_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            smvList:[],
            styleId : '',
            referenceId : '',
            activePage: 1,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
    }
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentDidMount() {
        var {referenceId , styleId } = this.props.location.state;
        this.setState({
            referenceId,styleId
        })
        StyleServices.listSMV(this.props.location.state.styleId,this.props.location.state.referenceId).then((response) => {
            if (response.message === "Operation Successful") {
                this.setState({ smvList: response.data })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })
    }
    submit(id) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>Are you sure?</h1>
                        <p>You want to delete this file?</p>
                        <button type="button" class="primary" onClick={onClose}>No</button> <button type="button" class="primary" onClick={() => {
                            this.removeSmv(id)
                            onClose()
                        }}>Yes, Delete it!</button>
                    </div>
                )
            }
        })

    };
    removeSmv(id) {
        StyleServices.removeSmv(id).then((response) => {
            if (response.message === "Successfully Deleted") {
                StyleServices.listSMV().then((response) => {
                    
                    if (response.message === "Operation Successful") {
                        this.setState({ smvList: response.data })
                    }
                }).catch((error) => {
                   UtilityService.errorMsg(this.msg)
                })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })
    }
    handlePageChange(pageNumber) {
        
        this.setState({ activePage: pageNumber });
    }
    navigationToNew(){
        var { state } =this.props.location
        this.props.history.push(`/SmvThread`,{ refId : this.state.referenceId , styleId : this.state.styleId, styleNumber:this.props.location.state.styleNumber })
    }
    render() {
        
        return (
            <Fragment>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
                    <div class="right-section">
                        <div class="row nopadding">
                                <div class="col-md-12 text-center p-2">
                                        <ul class="list-inline">
                                            <li><a href="#"></a></li>
                                            <li>
                                                <h6>Smv / ob calculation</h6></li>
                                            <li 
                                            class="pull-right"
                                            onClick={()=>this.navigationToNew()}
                                            >
                                                <span href="" style={{color: "#179286", paddingRight: "29px"}}>Add New</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-12 nopadding">

                                        <div class="card-container">
                                            <div class="table-container">
                                                <table class="striped">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Sample Type</th>
                                                            <th>size</th>
                                                            <th>chartPreparedBy</th>
                                                            <th>amendmentNumber</th>
                                                            <th colspan="4">Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        { this.state.smvList != undefined && Array.isArray(this.state.smvList) && this.state.smvList.length > 0 && this.state.smvList.map((smv,index)=>
                                                        <tr>
                                                            <td>{index+1}</td>
                                                                <td>{smv.sampleType.name}</td>
                                                                <td>{smv.size}</td>
                                                                <td>{smv.chartPreparedBy.firstName}{smv.chartPreparedBy.lastName}</td>
                                                                <td>{smv.amendmentNumber}</td>
                                                            

                                                                <td><a style={{ cursor: "pointer" }} onClick={() => this.props.history.push("/viewSMV?" + smv._id)} className="view" title="view"><i className="material-icons">visibility</i></a></td>
                                                                <td><a style={{ cursor: "pointer" }} onClick={() => this.props.history.push("/editSMV?" + smv._id)} className="edit" title="edit"><i className="material-icons">create</i></a></td>
                                                                <td><a style={{ cursor: "pointer" }} onClick={() => this.submit(smv._id)} className="delete" title="delete"><i className="material-icons">delete</i></a></td>
                                                        </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            
                                        </div>
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={2}
                                            totalItemsCount={30}
                                            pageRangeDisplayed={5}
                                            onChange={this.handlePageChange}
                                        />
                                    </div>
                                                        
                                </div>
                                                        
                                </div>
            </Fragment>
        );
    }
}

export default Smv_Ov_List;






// WEBPACK FOOTER //
// ./src/pages/listSMV/page.js